import styled from "styled-components";

export const Card = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    gap: 25px;
    padding: 16px;
    border-radius: 12px;
    color: #ddd;
`;
